import { NavigateFunction } from 'react-router';
import { rolesURLs } from '../../constants/rolesURLs';

export type UserDataType = {
  fullName: string;
  id: number;
  login: string;
  role: string;
  token: string;
  branchIds?: number[];
  queueIds?: number[];
};

export const setUserRole = (
  userData: UserDataType,
  nav: NavigateFunction,
  redirectPath?: string
) => {
  localStorage.setItem('user', JSON.stringify(userData));
  const roleRaw = userData.role ?? '';
  const role = roleRaw.trim();
  const currentRole = rolesURLs.find((e) =>
    typeof e.match === 'function' ? e.match(role) : e.role === role
  );
  if (!currentRole) {
    return;
  }
  const targetPath =
    redirectPath && isAllowedRedirectPath(redirectPath)
      ? redirectPath
      : currentRole.path;
  nav(targetPath);
};

const isAllowedRedirectPath = (path: string): boolean => {
  return path.startsWith('/admin') || path.startsWith('/main');
};

export const getUserData = (): UserDataType | string => {
  return localStorage.getItem('user') === null ? '' : JSON.parse(localStorage.getItem('user'));
};

export const isUserRole = () => {
  return localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).role : '';
};

export const getUserPath = () => {
  const role = (isUserRole() ?? '').trim();
  const currentRoleData = rolesURLs.find((e) =>
    typeof e.match === 'function' ? e.match(role) : e.role === role
  );
  return currentRoleData?.path ?? '';
};
